<div
    *ngIf="filter"
    [id]="filter.id + '.' + filter.id"
    class="agpr-savedFilterWrapper"
    [agprLoading]="loading"
>
    <agpr-text-input
        [id]="id + '.' + filter.id + '.search'"
        class="agpr-savedFilterWrapper-searchBar"
        icon="fa-regular fa-duotone fa-magnifying-glass"
        [(ngModel)]="searchQuery"
        (ngModelChange)="search()"
        [style]="style"
        ariaLabel="Monitoring.autoTaggingTopicFilterSearch"
    ></agpr-text-input>
    <agpr-scroll-panel>
        <div class="agpr-savedFilterWrapper-noContent" *ngIf="filteredOptions.length < 1">
            <agpr-message
                class="agpr-leftSidebar-noItemsMessage"
                [severity]="severity.noContent"
            >
                {{ 'Common.filter.noContent' | localize }}
            </agpr-message>
        </div>

        <div *ngIf="hasFavoriteItems && filteredOptions.length > 0">
            <label class="agpr-savedFilterWrapper-list-label"> {{ 'Common.filter.savedFilters.favorites' | localize }} </label>
            <ul
                class="agpr-savedFilterWrapper-list"
                [attr.aria-label]="'filter' | localize"
            >
                <ng-container *ngFor="let item of filteredOptions; let i = index">
                    <ng-container *ngIf="item.value.favorite">
                        <ng-container
                            *ngTemplateOutlet="checkboxOption, context: {item: item, index: i, type: '.favorite'}"
                        ></ng-container>
                    </ng-container>
                </ng-container>
            </ul>
        </div>
        <div *ngIf="filteredOptions.length > 0">
            <label class="agpr-savedFilterWrapper-list-label"> {{ 'Common.filter.savedFilters' | localize }} </label>
            <ul class="agpr-savedFilterWrapper-list">
                <ng-container
                    *ngFor="let item of filteredOptions; let i = index"
                >
                    <ng-container
                        *ngTemplateOutlet="checkboxOption, context: {item: item, index: i, type: '.regular'}"
                    ></ng-container>
                </ng-container>
            </ul>
        </div>
    </agpr-scroll-panel>
</div>

<ng-template #checkboxOption let-item="item" let-i="index" let-suffix="type">
    <li class="agpr-savedFilterWrapper-item">
        <agpr-checkbox
            [id]="id + '.' + filter.id + suffix +'.checkbox-' + i"
            class="agpr-savedFilterWrapper-checkbox"
            [name]="'savedFilterWrapper-' + filter.id"
            [(ngModel)]="value"
            [value]="item.value"
            [label]="item.label"
            (ngModelChange)="handleChange()"
        >
        </agpr-checkbox>
        <agpr-button
            class="agpr-savedFilterWrapper-favorite"
            [icon]="item.value.favorite ? 'fa fa-star' : 'fa-regular fa-star'"
            [tooltip]="item.value.favorite ? 'Common.filter.savedFilters.removeFavorites' : 'Common.filter.savedFilters.addFavorites'"
            tooltipPosition="top"
            (click)="editFavorite(item.value)"
        ></agpr-button>
    </li>
</ng-template>